module.exports = __webpack_public_path__ + "static/img/7en.42b160c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/7en.png
// module id = 2Fqz
// module chunks = 0